"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const detect_node_1 = __importDefault(require("detect-node"));
const fast_printf_1 = require("fast-printf");
const globalthis_1 = __importDefault(require("globalthis"));
const is_circular_1 = __importDefault(require("is-circular"));
const json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
const constants_1 = require("../constants");
const globalThis = globalthis_1.default();
let domain;
if (detect_node_1.default) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    domain = require('domain');
}
const getParentDomainContext = () => {
    var _a;
    if (!domain) {
        return {};
    }
    const parentRoarrContexts = [];
    let currentDomain = process.domain;
    if (!currentDomain || !currentDomain.parentDomain) {
        return {};
    }
    while (currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.parentDomain) {
        currentDomain = currentDomain.parentDomain;
        if ((_a = currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.roarr) === null || _a === void 0 ? void 0 : _a.context) {
            parentRoarrContexts.push(currentDomain.roarr.context);
        }
    }
    let domainContext = {};
    for (const parentRoarrContext of parentRoarrContexts) {
        domainContext = {
            ...domainContext,
            ...parentRoarrContext,
        };
    }
    return domainContext;
};
const getFirstParentDomainContext = () => {
    var _a, _b;
    if (!domain) {
        return {};
    }
    let currentDomain = process.domain;
    if ((_a = currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.roarr) === null || _a === void 0 ? void 0 : _a.context) {
        return currentDomain.roarr.context;
    }
    if (!currentDomain || !currentDomain.parentDomain) {
        return {};
    }
    while (currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.parentDomain) {
        currentDomain = currentDomain.parentDomain;
        if ((_b = currentDomain === null || currentDomain === void 0 ? void 0 : currentDomain.roarr) === null || _b === void 0 ? void 0 : _b.context) {
            return currentDomain.roarr.context;
        }
    }
    return {};
};
const defaultContext = {};
const createLogger = (onMessage, parentContext) => {
    const log = (a, b, c, d, e, f, g, h, i, j) => {
        const time = Date.now();
        const sequence = globalThis.ROARR.sequence++;
        let context;
        let message;
        if (typeof a === 'string') {
            if (!domain || process.domain === null) {
                context = parentContext || defaultContext;
            }
            else {
                context = {
                    ...getFirstParentDomainContext(),
                    ...parentContext,
                };
            }
        }
        else {
            context = {
                ...getFirstParentDomainContext(),
                ...parentContext,
                ...a,
            };
        }
        if (context !== defaultContext && is_circular_1.default(context)) {
            context = JSON.parse(json_stringify_safe_1.default(context));
        }
        if (typeof a === 'string' && b === undefined) {
            message = a;
        }
        else if (typeof a === 'string') {
            message = fast_printf_1.printf(a, b, c, d, e, f, g, h, i, j);
        }
        else {
            if (typeof b !== 'string') {
                throw new TypeError('Message must be a string.');
            }
            message = fast_printf_1.printf(b, c, d, e, f, g, h, i, j);
        }
        onMessage({
            context,
            message,
            sequence,
            time,
            version: '1.0.0',
        });
    };
    log.child = (context) => {
        if (typeof context === 'function') {
            return createLogger((message) => {
                const nextMessage = context(message);
                if (typeof nextMessage !== 'object' || nextMessage === null) {
                    throw new Error('Child middleware function must return a message object.');
                }
                onMessage(nextMessage);
            }, parentContext);
        }
        return createLogger(onMessage, {
            ...getFirstParentDomainContext(),
            ...parentContext,
            ...context,
        });
    };
    log.getContext = () => {
        return {
            ...getFirstParentDomainContext(),
            ...parentContext || defaultContext,
        };
    };
    log.adopt = async (routine, context) => {
        if (!domain) {
            return routine();
        }
        const adoptedDomain = domain.create();
        return adoptedDomain
            .run(() => {
            adoptedDomain.roarr = {
                context: {
                    ...getParentDomainContext(),
                    ...context,
                },
            };
            return routine();
        });
    };
    log.trace = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.trace,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    log.debug = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.debug,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    log.info = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.info,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    log.warn = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.warn,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    log.error = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.error,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    log.fatal = (a, b, c, d, e, f, g, h, i, j) => {
        log.child({
            logLevel: constants_1.logLevels.fatal,
        })(a, b, c, d, e, f, g, h, i, j);
    };
    return log;
};
exports.default = createLogger;
